document.addEventListener('DOMContentLoaded', function() {
  const savingUseSlider = document.querySelector('.saving-use-items-slider');
  
  if (savingUseSlider) {
    new Swiper('.saving-use-items-slider', {
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: '.saving-use-items-slider .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.saving-use-items-button-next',
        prevEl: '.saving-use-items-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    });
  }
});
